import { h, defineAsyncComponent } from 'vue'
import { uiState } from '@/helpers/uiPrefs.js'

// A route component that renders one of several versions of a page, picked by a key in
// the shared ui state (the user menu writes it). Every version is a lazy chunk;
// changing the setting swaps them in place on the current route. `wrapClass` maps a
// version to a display:contents wrapper so a polish stylesheet can target it without
// touching that page's own file (see assets/orderhist-classic.css).
export function byVariant (name, stateKey, loaders, fallback, wrapClass = {}) {
  const pages = {}
  Object.keys(loaders).forEach(key => { pages[key] = defineAsyncComponent(loaders[key]) })
  return {
    name,
    render () {
      const key = pages[uiState[stateKey]] ? uiState[stateKey] : fallback
      const page = h(pages[key])
      return wrapClass[key] ? h('div', { class: wrapClass[key] }, [page]) : page
    },
  }
}
